import React from 'react';

import closeSmallTokens from '@amzn/meridian-tokens/base/icon/close-small';
import Button from '@amzn/meridian/button';
import Column from '@amzn/meridian/column';
import Divider from '@amzn/meridian/divider';
import Heading from '@amzn/meridian/heading';
import Icon from '@amzn/meridian/icon';
import Row from '@amzn/meridian/row';
import Sheet from '@amzn/meridian/sheet';

import { AppContext } from 'src/contexts/appContext';

export const RightSideBar = () => {
    const { isRightSideBarOpen, setIsRightSideBarOpen, rightSideBarContent } = React.useContext(AppContext);

    const handleCloseRightSideBar = () => setIsRightSideBarOpen(false);

    const heading = (
        <>
            <Row alignmentHorizontal="justify" alignmentVertical="center">
                <Heading level={3}>{rightSideBarContent.heading ?? ''}</Heading>
                <Button onClick={handleCloseRightSideBar} type="icon" data-testid="right-sidebar-close-btn">
                    <Icon tokens={closeSmallTokens} />
                </Button>
            </Row>
            <Divider />
        </>
    );

    return (
        <Sheet type="push" side="end" open={isRightSideBarOpen} onClose={handleCloseRightSideBar}>
            <Column width={360} height={'100%'}>
                {!rightSideBarContent.omitHeading && heading}
                {rightSideBarContent.mainBody ?? ''}
            </Column>
        </Sheet>
    );
};
